module.exports = __webpack_public_path__ + "static/media/create-room-button-icon.10f491aa.svg";